import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=54c14f83&scoped=true&"
import script from "./ProductDetail.ts?vue&type=script&lang=ts&"
export * from "./ProductDetail.ts?vue&type=script&lang=ts&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=54c14f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c14f83",
  null
  
)

export default component.exports